import Header from "../../../../Components/Header/Header"
import Sidebar from "../../../../Components/Sidebar/Sidebar"
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import ProjectNamePopup from "./ProjectNamePopup"
import DeletePopup from "../GardenPopup/DeletePopup"
import { ProjectNameDataDDL } from "../../../../Components/CommonDDL/ProjectNameDataDDL"
import { useAuthState } from "../../../../Helper/Context"
import { useDispatch, useSelector } from "react-redux"
import { ProjectDeleteAPI, ProjectTableDataAPI } from "../../../../Redux/SidebarMasterSlice/ProjectNameSlice"
import { Pegination } from "../../../../Components/Pegination/Pegination"
import { Loading } from "../../../../Helper/Loading"
import { WardNameDataDDL } from "../../../../Components/CommonDDL/WardNameDataDDL"
import { ProjectTypeDataDDL } from "../../../../Components/CommonDDL/ProjectTypeDataDDL"
import { useSearchParams } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { WorkTypeDDL } from "../../../../Components/CommonDDL/WorkTypeDDL"

export const ProjectName = () => {

    const { t } = useTranslation()

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let ProjectTypeFlag = searchParams.get("ProjectTypeFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let Lang = searchParams.get("Lang")
    // console.log('ProjectTypeId',ProjectTypeId)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [From, setFrom] = useState(1)
    const [To, setTo] = useState(10)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)
    const [SectorMasterPopupShow, setSectorMasterPopupShow] = useState()
    const [ProjectNamePopupShow, setProjectNamePopupShow] = useState()
    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')
    const [IsClear, setIsClear] = useState(false)

    const [MasterPopupShow, setMasterPopupShow] = useState()

    const [ProjectName, setProjectName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [ProjectType, setProjectType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [WorkType, setWorkType] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Language, setLanguage] = useState({
        DDL: [],
        ID: 0,
        Label: ''
    })

    useEffect(() => {
        setLanguage({
            ...Language,
            DDL: [],
            ID: 0,
            Label: localStorage.getItem('LanguageChange'),
        })
    }, [])

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setProjectNamePopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setProjectNamePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setProjectNamePopupShow(false)
    }

    const handleClear = () => {
        setFrom(1)
        setTo(10)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setProjectName({
            ...ProjectName,
            ID: 0,
            Label: 'Select...'
        })
        setWorkType({
            ...WorkType,
            ID: 0,
            Label: 'Select...'
        })
        setProjectType({
            ...ProjectType,
            ID: 0,
            Label: 'Select...'
        })
    }

    useEffect(() => {

        const data = {
            M_ProjectID: ProjectName.ID,
            ProjectName: '',
            M_WorkTypeID: WorkType.ID,
            M_UsersID: UserID,
            token: token,
            From: From,
            To: To,
            // M_WardID: WardName.ID,
            M_ProjectType: ProjectTypeFlag
        }
        dispatch(ProjectTableDataAPI({ data }))
    }, [IsPost, To, IsClear, ProjectName.ID, WorkType.ID])

    const { tableData, isLoading } = useSelector(state => state.ProjectTableData)

    const handleDeleteApi = (item) => {
        const data = {
            M_ProjectID: item.m_ProjectID,
            M_UserID: UserID,
            token: token,
            handleIsPost: handleIsPost
        }
        dispatch(ProjectDeleteAPI({ data }))
    }

    const { isDeleteLoading } = useSelector(state => state.ProjectDeleteData)

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [ProjectName.ID, ProjectType.ID])

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select Ward",
    // })

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                    Language={Language}
                    setLanguage={setLanguage}
                />
                <div className="wrapper">
                    <Sidebar
                        Language={Language}
                        ProjectTypeId={ProjectTypeId} />
                    <div className="content1">
                        <div className="row m-1 py-1 pb-4 master_border">
                            <div>
                                <h5 className="ps-1 py-1 ">{t('AdminDashboard.Admin_Sidebar_Name.Project_Name')}</h5>
                                <div className="col-12 col-lg-7 float-end">
                                    <i className="fa-solid fa-plus btn btn-secondary float-end mb-2"
                                        style={{ color: "white", marginTop: '-2.5em' }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 ">
                                <div className="col-12 py-1 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: " #27466317" }}>
                                    <div className="col-12  ">

                                        <div className="row py-1 rounded2">
                                            <div className="col-12 col-md-5 col-lg-3">
                                                <WorkTypeDDL
                                                    WorkType={WorkType}
                                                    setWorkType={setWorkType}
                                                    IsPost={IsPost}
                                                    Language={Language}
                                                    Flag1='ProjectType'
                                                />
                                            </div>

                                            <div className="col-12 col-md-6 col-lg-3">
                                                <ProjectNameDataDDL
                                                    ProjectName={ProjectName}
                                                    setProjectName={setProjectName}
                                                    IsPost={IsPost}
                                                />

                                            </div>

                                            <div className="col-12 col-md-1 col-lg-2 mt-1 mt-lg-4 mt-md-4" >
                                                <button type="button" className="btn-clear btn btn-primary"
                                                    onClick={handleClear}
                                                >Clear</button>
                                            </div>
                                        </div>
                                        <div className="row mob_table table-responsive pt-1">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">
                                                <thead>
                                                    <tr >
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Project Type</th>
                                                        <th>Project Name</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr style={{ width: '100%' }}>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum}</td>
                                                                <td>{item.workTypeName ? item.workTypeName : '-'}</td>
                                                                {/* <td>{item.projectType ? item.projectType : '-'}</td> */}
                                                                <td>{item.projectName ? item.projectName : '-'}</td>
                                                                <td style={{ textAlign: "center", width: '7%' }}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square"
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        ></i>
                                                                    </span>

                                                                    <DeletePopup
                                                                        open={DeletePopupShow}
                                                                        item={item}
                                                                        handleDeleteApi={handleDeleteApi}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ))
                                                            :
                                                            <>No data found</>
                                                    }

                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                                IsClear={IsClear}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    ProjectNamePopupShow &&
                    <ProjectNamePopup
                        open={ProjectNamePopupShow}
                        handleIsPost={handleIsPost}
                        handleOnCloseClick={handleOnCloseClick}
                        rowData={rowData}
                        Flag={apiFlag}
                        ProjectTypeFlag={ProjectTypeFlag}
                    />
                }
            </div>
        </>
    )
}